module.exports = __webpack_public_path__ + "static/assets/173e52e04ff6f2036add0558812948e6.gif";